import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => {
  return {
    drawerContent: {
      display: "flex",
      height: "100%",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    navMobileArea: {
      display: "flex",
      justifyContent: "space-between",
    },
    listStyle: {
      borderLeft: 6,
      borderStyle: "solid",
      backgroundColor: "#000",
    },
    listStyleSelected: {
      borderLeft: 6,
      borderStyle: "solid",
      borderLeftColor: "#658D1B",
      backgroundColor: "#2b2b2b",
      '&:hover': {
        backgroundColor: '#2b2b2b',
        borderLeftColor: "#658D1B",
      }
    },
    linkStyle: {
      color: theme.palette.common.white,
    },
    linkActive: {
      borderColor: theme.palette.primary.main,
    },
    logoArea: {
      textAlign: "center",
    },
    logo: {
      maxWidth: "90%",
    },
    userName: {
      color: theme.palette.common.white,
      [theme.breakpoints.up("md")]: {
        width: theme.sizes.drawer.desktopWidth - 75,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
    },
    userRole: {
      color: theme.palette.common.white,
      opacity: 0.6,
    },
    userIcon: {
      color: theme.palette.common.white,
      opacity: 0.6,
    },
    exitButtonLabel: {
      color: theme.palette.common.white,
      justifyContent: "space-between",
    },
    exitButton: {
      borderRadius: 0,
      height: 48,
    },
    menuMobileTitle: {
      width: '100%',
      display: "flex",
      justifyContent: "space-between",
    },
    searchIcon: {
      color: theme.palette.common.white
    }
  };
});

export default useStyles;
